export const data = {
  tools: {
    tags: [
      "UX Design",
      "UI Design",
      "Image",
      "Color",
      "Icon",
      "Font",
      "Video",
      "Audio",
      "Vector",
      "AI",
      "Animation",
      "No Code",
      "Productivity",
      "Others",
    ],
    radios: [
      { value: "Free", label: "Free", icon: "free" },
      { value: "Freemium", label: "Freemium", icon: "freemium" },
      { value: "Paid", label: "Paid", icon: "paid" },
    ],
    checks: [
      { value: "Apple", label: "Apple", icon: "apple" },
      { value: "Windows", label: "Windows", icon: "windows" },
      { value: "Browser", label: "Browser", icon: "browser" },
      { value: "Linux", label: "Linux", icon: "linux" },
    ],
  },
  resos: {
    tags: [
      "UX Design",
      "UI Design",
      "Color",
      "Icon",
      "Font",
      "Image",
      "Video",
      "Audio",
      "Vector",
      "Animation",
      "Data",
      "Others",
    ],
  },
  ideaz: {
    tags: [
      "UX Design",
      "UI Design",
      "Website",
      "App",
      "Icon",
      "Font",
      "Mockup",
      "Branding",
      "Vector",
      "Animation",
      "Art",
      "Others",
    ],
  },
  apps: {
    tags: [
      "UX Design",
      "UI Design",
      "Website",
      "App",
      "Icon",
      "Font",
      "Mockup",
      "Branding",
      "Vector",
      "Animation",
      "Art",
      "Others",
    ],
    checks: [
      { value: "Apple", label: "Apple", icon: "apple" },
      { value: "Android", label: "Android", icon: "android" },
    ],
  },
};
